// extracted by mini-css-extract-plugin
export var singlePublicationDescriptionContent = "index-module--single-publication-description-content--8FGbZ";
export var singlePublicationDescriptionHeader = "index-module--single-publication-description-header--urjQT";
export var singlePublicationMetaContent = "index-module--single-publication-meta-content--CkEGM";
export var singlePublicationPublisherContent = "index-module--single-publication-publisher-content--GBkJb";